export default {
  flameBold: 'flameBold',
  flameRegular: 'flameRegular',
  flameSansRegular: 'flameSansRegular'
};
